"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ILogger_1 = require("./ILogger");
var LSLogger_1 = require("./LSLogger");
var SQlLogger_1 = require("./SQlLogger");
var DBLogger_1 = require("./DBLogger");
var Logger = (function () {
    function Logger() {
    }
    Logger.getInstance = function (name, type, url, onLogs, interval) {
        var logger;
        try {
            if (type === ILogger_1.LogModel.LocalStorage && LSLogger_1.LSLogger.isSupport) {
                logger = new LSLogger_1.LSLogger(name, url, interval, onLogs, Logger.PER_LENGTH);
            }
            else if (type === ILogger_1.LogModel.Websql && LSLogger_1.LSLogger.isSupport) {
                logger = new SQlLogger_1.SQlLogger(name, url, interval, onLogs, Logger.PER_LENGTH);
            }
            else if (type === ILogger_1.LogModel.LocalStorage && LSLogger_1.LSLogger.isSupport) {
                logger = new DBLogger_1.DBLogger(name, url, interval, onLogs, Logger.PER_LENGTH);
            }
        }
        catch (e) {
        }
        return logger;
    };
    Logger.PER_LENGTH = 30;
    return Logger;
}());
exports.Logger = Logger;
//# sourceMappingURL=Logger.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/limi-lib/dist/lib/limi/log/Logger.js
// module id = Rqlk
// module chunks = 0